import { css } from "@linaria/core";
import React from "react";
import { colors, spacings } from "@ui/Theme";
import Text from "@ui/Text";
import t from "../../../../../i18n";
import formatDate from "../../../../../ui/i18n/formatDate";

const quantityFieldName = css`
  color: ${colors.carbon900};
`;
const quantityFieldDescription = css`
  margin-top: ${spacings.xxs};
  color: ${colors.carbon800};
`;
const quantityFieldFormula = css`
  margin-top: ${spacings.s};
  color: ${colors.carbon800};
`;
const quantityFieldValue = css`
  margin-top: ${spacings.m};
  color: ${colors.carbon800};
`;

export const QuantityChartTooltip = ({
  name,
  description,
  formula,
  formulaApplicationPeriod,
  timezone,
  option,
}: {
  name: string;
  description: string | null;
  formula?: string | null;
  formulaApplicationPeriod?: { from: Date; to: Date | null } | null;
  timezone?: string;
  option: {
    label: string;
    value: string;
  } | null;
}) => {
  const from = formulaApplicationPeriod
    ? formatDate(formulaApplicationPeriod.from, "date", timezone ?? null)
    : null;
  const to = formulaApplicationPeriod
    ? formulaApplicationPeriod.to === null
      ? null
      : formatDate(formulaApplicationPeriod.to, "date", timezone ?? null)
    : null;
  const formulaPeriodLabel = formulaApplicationPeriod
    ? t("project.settings.quantity.side_panel.section.formula_input.usage_period", from, to)
    : null;

  return (
    <div>
      <Text type="h4" className={quantityFieldName}>
        {name}
      </Text>
      <Text type="body2" className={quantityFieldDescription}>
        {description}
      </Text>
      {option ? (
        <Text as="p" className={quantityFieldValue}>
          {t("commun.tooltip.label_value", {
            label: (
              <Text type="body1" as="span">
                {option.label}
              </Text>
            ),
            value: (
              <Text type="body1SemiBold" as="span">
                {option.value}
              </Text>
            ),
          })}
        </Text>
      ) : null}
      {formula && (
        <Text type="body2" className={quantityFieldFormula}>
          {t("commons.quantities.selectFilter.type.formula")}{" "}
          {formulaPeriodLabel ? `(${formulaPeriodLabel})` : null}:
          {formulaPeriodLabel ? <br /> : " "}
          {formula}
        </Text>
      )}
    </div>
  );
};
